const func = () => {
	//console.log('here');
};

export default func;
